import React, { useEffect, useState } from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import {
  AUTHENTICATED_ENTRY,
  COMING_SOON_ENTRY,
  NOT_FOUND_ENTRY,
} from "configs/AppConfig";
import { GetProtectedRoutes, publicRoutes } from "configs/RoutesConfig";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import AppRoute from "./AppRoute";
import { useUserData } from "components/UserDataContext/UserDataContext";
import Home from "views/app-views/Home/Home";
import NoAccess from "components/layout-components/NoAccess";

const Routes = () => {
  const userData = useUserData();
  const [protectedRoutes, setProtectedRoutes] = useState([]);
  useEffect(() => {
    if (userData.factoryRoles) {
      setProtectedRoutes(GetProtectedRoutes(userData.factoryRoles));
    }
  }, [userData.factoryRoles]);
  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        {protectedRoutes.map((route, index) => {
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
        {protectedRoutes.length > 0 && (
          <Route
            path="/app/*"
            element={<AppRoute routeKey="no-access" component={NoAccess} />}
          />
        )}
      </Route>
      <Route path="/" element={<PublicRoute />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>

    </RouterRoutes>
  );
};

export default Routes;
